var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "site-carcass"
  }, [_c('AppPromo', {
    attrs: {
      "options": {
        interval: 0,
        showForCertainOS: ['android'],
        identifyer: '#123wqdsaxc',
        count: 9999
      },
      "link": "https://play.google.com/store/apps/details?id=com.x05ru.release",
      "description": "Бесплатно в Google Play"
    }
  }), _vm._v(" "), _c('DarkstoreBar'), _vm._v(" "), _c('Header'), _vm._v(" "), !_vm.statusPage ? _c('StatusBlock', {
    attrs: {
      "size": "l",
      "type": "loading"
    }
  }) : _c('main', {
    staticClass: "site-carcass__container"
  }, [_c('div', {
    staticClass: "site-carcass__content"
  }, [_c('div', {
    staticClass: "nam-20"
  }, [_c('div', {
    staticClass: "nam-20__inner"
  }, [_c('div', {
    ref: "headerSticky",
    staticClass: "nam-20__header"
  }, [_c('div', {
    staticClass: "nam-20__header-inner"
  }, [_c('div', {
    staticClass: "nam-20__header-inner-content"
  }, [_c('img', {
    staticClass: "nam-20__header-inner-content-logo",
    attrs: {
      "src": require("assets/images/nam20/logo.svg"),
      "alt": "Нам 20"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "nam-20__header-inner-content-text"
  }, [_vm._v("\n                  Масштабная акция "), _c('br'), _vm._v("\n                  в честь нашего юбилея!\n                ")])]), _vm._v(" "), _c('div', {
    staticClass: "nam-20__header-inner-tabs",
    class: [{
      'nam-20__header-inner-tabs-sticky': _vm.isSticky
    }]
  }, [_vm._l(_vm.tabs, function (item, index) {
    return _c('div', {
      key: index,
      staticClass: "nam-20__header-inner-tabs-tab"
    }, [_c('nuxt-link', {
      staticClass: "link link_wu",
      attrs: {
        "to": item.link
      }
    }, [_c('div', {
      staticClass: "nam-20__header-inner-tabs-tab-desktop",
      class: [{
        'nam-20__header-inner-tabs-tab-desktop-active': _vm.route.fullPath === item.link
      }]
    }, [_vm._v("\n                      " + _vm._s(item.title) + "\n                    ")]), _vm._v(" "), _c('div', {
      staticClass: "nam-20__header-inner-tabs-tab-mobile",
      class: [{
        'nam-20__header-inner-tabs-tab-mobile-new': item.title === 'Активности'
      }]
    }, [_c('div', {
      staticClass: "nam-20__header-inner-tabs-tab-mobile-img-wrapper",
      class: [{
        'nam-20__header-inner-tabs-tab-mobile-img-wrapper-active': _vm.route.fullPath === item.link
      }, {
        'nam-20__header-inner-tabs-tab-mobile-img-wrapper-sticky': _vm.isSticky
      }]
    }, [_c('img', {
      staticClass: "nam-20__header-inner-tabs-tab-mobile-img-inner",
      attrs: {
        "src": _vm.route.fullPath === item.link ? item.img.active : item.img.notActive,
        "alt": ""
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "nam-20__header-inner-tabs-tab-mobile-title",
      class: [{
        'nam-20__header-inner-tabs-tab-mobile-title-active': _vm.route.fullPath === item.link
      }, {
        'nam-20__header-inner-tabs-tab-mobile-title-sticky': _vm.isSticky && _vm.route.fullPath === item.link
      }]
    }, [_vm._v("\n                        " + _vm._s(item.titleMobile ? item.titleMobile : item.title) + "\n                      ")])])])], 1);
  }), _vm._v(" "), _c('div', {
    staticClass: "nam-20__header-inner-tabs-bonus-tab",
    on: {
      "click": function ($event) {
        _vm.isAuth ? _vm.showBonusModal = true : _vm.enableAuthModal();
      }
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.isAuth ? ("Ваш счёт " + (_vm.bonusCount)) : 'Войти') + "\n                  "), _vm.isAuth ? _c('img', {
    staticClass: "nam-20__header-inner-tabs-bonus-tab-svg",
    attrs: {
      "src": require("assets/images/nam20/bonus.svg"),
      "alt": "бонусов"
    }
  }) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "nam-20__header-inner-tabs-bonus-tab-mobile",
    on: {
      "click": function ($event) {
        _vm.isAuth ? _vm.showBonusModal = true : _vm.enableAuthModal();
      }
    }
  }, [_vm.isAuth ? _c('div', {
    staticClass: "nam-20__header-inner-tabs-bonus-tab-mobile-count",
    class: [{
      'nam-20__header-inner-tabs-bonus-tab-mobile-count-active': _vm.showBonusModal
    }, {
      'nam-20__header-inner-tabs-bonus-tab-mobile-count-sticky': _vm.isSticky
    }]
  }, [_vm._v("\n                    " + _vm._s(_vm.bonusCount) + "\n                  ")]) : [_c('img', {
    staticClass: "nam-20__header-inner-tabs-tab-mobile-img-inner",
    class: [{
      'nam-20__header-inner-tabs-tab-mobile-img-inner-sticky': _vm.isSticky
    }],
    attrs: {
      "src": require("assets/images/nam20/login.svg"),
      "alt": "Войти"
    }
  })], _vm._v(" "), _c('div', {
    staticClass: "nam-20__header-inner-tabs-bonus-tab-mobile-title"
  }, [_vm._v("\n                    " + _vm._s(_vm.isAuth ? 'Ваш счёт' : 'Войти') + "\n                  ")])], 2)], 2)])]), _vm._v(" "), _c('ViewportToogle', {
    scopedSlots: _vm._u([{
      key: "desktop",
      fn: function () {
        return [_c('MainSlider', {
          staticClass: "nam-20__slider-desktop",
          attrs: {
            "list": _vm.desktopBanners
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function (_ref) {
              var el = _ref.el,
                  active = _ref.active;
              return [_c('MainSliderEl', {
                key: el.id,
                attrs: {
                  "img": el.image,
                  "sale": el,
                  "link": el.link,
                  "active": active
                },
                nativeOn: {
                  "click": function ($event) {
                    _vm.saleSelect(), _vm.scrollFromBanners(el);
                  }
                }
              })];
            }
          }])
        })];
      },
      proxy: true
    }, {
      key: "mobile",
      fn: function () {
        return [_c('BaseRowSlider', {
          staticClass: "nam-20__slider-mobile",
          attrs: {
            "list": _vm.mobileBanners,
            "offset-between-elements": 10
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function (_ref2) {
              var el = _ref2.el;
              return [_c('StoriesSlide', {
                attrs: {
                  "link": el.link,
                  "src": el.image,
                  "alt": el.name
                },
                nativeOn: {
                  "click": function ($event) {
                    _vm.saleSelect(), _vm.scrollFromBanners(el);
                  }
                }
              })];
            }
          }])
        })];
      },
      proxy: true
    }])
  }), _vm._v(" "), _c('div', {
    ref: "bannerPage"
  }), _vm._v(" "), _c('nuxt')], 1)]), _vm._v(" "), _c('div', {
    staticClass: "nam20__socials"
  }, [_c('h3', {
    staticClass: "nam20__socials-title"
  }, [_vm._v("\n          Следите за ходом акции "), _c('br'), _vm._v(" в наших соцсетях\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "nam20__socials-links"
  }, [_c('a', {
    attrs: {
      "href": _vm.socialStore.social.telegramGroup
    }
  }, [_c('img', {
    staticClass: "nam20__socials-links-telegram",
    attrs: {
      "src": require("assets/images/nam20/telegram.svg"),
      "alt": "telegram"
    }
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "href": _vm.socialStore.social.vk
    }
  }, [_c('img', {
    staticClass: "nam20__socials-links-vk",
    attrs: {
      "src": require("assets/images/nam20/vk.svg"),
      "alt": "vk"
    }
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "href": _vm.socialStore.social.youTube
    }
  }, [_c('img', {
    staticClass: "nam20__socials-links-youtube",
    attrs: {
      "src": require("assets/images/nam20/youtube.svg"),
      "alt": "youtube"
    }
  })])]), _vm._v(" "), _c('h5', {
    staticClass: "nam20__socials-subtitle"
  }, [_vm._v("\n          Там тоже раздают бонусы\n        ")])]), _vm._v(" "), _c('h5', {
    staticClass: "nam20__rules",
    on: {
      "click": function ($event) {
        _vm.showRulesModal = true;
      }
    }
  }, [_vm._v("\n        Правила проведения акции\n      ")]), _vm._v(" "), _c('Modal', {
    staticClass: "nam20__rules-modal",
    attrs: {
      "title": "",
      "max-width": "1500px",
      "show": _vm.showRulesModal
    },
    on: {
      "close": function ($event) {
        _vm.showRulesModal = false;
      }
    }
  }, [_c('p', [_vm._v("1. Общие положения ")]), _vm._v(" "), _c('p', [_vm._v("1.1. Настоящие правила (далее - “Правила”) регламентируют порядок участия в акции “Активности”.")]), _vm._v(" "), _c('p', [_vm._v("1.2. Организатором Акции является компания 05.ru (далее - “Организатор”).")]), _vm._v(" "), _c('p', [_vm._v("\n          1.3. Акция не является лотерей или иным мероприятием, основанным на риске, и носит исключительно информационный характер о сайте www.05.ru\n          и проводится с целью продвижения услуг Организатора и привлечения клиентов.\n        ")]), _vm._v(" "), _c('p', [_vm._v("2. Условия участия в Акции")]), _vm._v(" "), _c('p', [_vm._v("2.1. Участником Акции может стать только дееспособное физическое лицо, достигшее совершеннолетия, и выполнившее все условия проведения Акции.")]), _vm._v(" "), _c('p', [_vm._v("2.2. Для участия в Акции Участнику необходимо:")]), _vm._v(" "), _c('p', [_vm._v("\n          зарегистрироваться/авторизоваться на сайте 05.ru\n          пройти игру на сайте компании или выполнить задание\n        ")]), _vm._v(" "), _c('p', [_vm._v("2.3. Запрещается повторная регистрация одного Участника под различными email- аккаунтами и телефонными номерами.")]), _vm._v(" "), _c('p', [_vm._v("2.4. Сроки проведения Акции:")]), _vm._v(" "), _c('p', [_vm._v("с 1 сентября 2023 года по 26 октября 2023 года.")]), _vm._v(" "), _c('p', [_vm._v("2.5. Организатор вправе в любой момент по своему усмотрению без предварительного уведомления изменить условия Акции, в том числе сроки проведения, без указания оснований")]), _vm._v(" "), _c('p', [_vm._v("2.6. В случае возникновения причины, в том числе неконтролируемой̆ Организатором Акции, которая препятствует должному проведению Акции, затрагивает ее безопасность, честность и целостность, Организатор Акции вправе в одностороннем порядке приостановить или прекратить проведение Акции.")]), _vm._v(" "), _c('p', [_vm._v("3. Порядок подведения Акции:")]), _vm._v(" "), _c('p', [_vm._v("\n          3.1. Участник  Акции получает следующий приз (далее - “Приз”): до 550 бонусов за прохождение игр и до 300 бонусов за выполнение заданий.\n          Подробнее о бонусной системе https://05.ru/bonus/\n        ")]), _vm._v(" "), _c('p', [_vm._v("3.2. Сроки начисления бонусов – 3  рабочих дня.")]), _vm._v(" "), _c('p', [_vm._v("3.3. Срок использования бонусов – 31 день со дня начисления.")])]), _vm._v(" "), _c('Modal', {
    staticClass: "nam20__bonus-modal",
    attrs: {
      "title": "",
      "max-width": "505px",
      "overlay-theme": "light",
      "show": _vm.showBonusModal
    },
    on: {
      "close": function ($event) {
        _vm.showBonusModal = false;
      }
    },
    scopedSlots: _vm._u([{
      key: "title",
      fn: function () {
        return [_c('div', {
          staticClass: "nam20__bonus-modal-title"
        }, [_vm._v("\n            " + _vm._s(_vm.userName) + "\n          ")])];
      },
      proxy: true
    }])
  }, [_vm._v(" "), _c('div', {
    staticClass: "nam20__bonus-modal-body"
  }, [_c('h2', {
    staticClass: "nam20__bonus-modal-body-title"
  }, [_vm._v("\n            Ваш счёт\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "nam20__bonus-modal-body-count"
  }, [_vm._v("\n            " + _vm._s(_vm.bonusCount) + "\n            "), _c('img', {
    staticClass: "nam20__bonus-modal-body-count-svg",
    attrs: {
      "src": require("assets/images/nam20/bonus.svg"),
      "alt": "bonus"
    }
  })])])])], 1)]), _vm._v(" "), _c('Footer'), _vm._v(" "), _c('GlobalTools')], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }